import { LlmOptions } from '@websolutespa/bom-mixer-llm';
import { blocks } from './blocks';
import { components } from './components';

export function llmPlugin(options: LlmOptions): LlmOptions {
  const config: LlmOptions = {
    ...options,
    blocks: {
      ...options.blocks,
      ...blocks,
    },
    components: {
      ...options.components,
      ...components,
    },
    onInit: (state) => {
      console.log('llmPlugin.onInit', state);
    },
  };
  return config;
}
